import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

interface StorageImageProps {
  path: string | null | undefined;
  alt: string;
  className?: string;
}

export default function StorageImage({ path, alt, className }: StorageImageProps) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!path) {
      setUrl(null);
      return;
    }

    if (path.startsWith('http')) {
      setUrl(path);
      return;
    }

    const fetchUrl = async () => {
      const { data, error } = await supabase.storage
        .from('public')
        .createSignedUrl(path, 3600);
      if (!error && data?.signedUrl) {
        setUrl(data.signedUrl);
      }
    };

    fetchUrl();
  }, [path]);

  if (!url) {
    return (
      <div className={`bg-background-200 flex items-center justify-center ${className || ''}`}>
        <i className="ri-image-line text-foreground-300 text-2xl" />
      </div>
    );
  }

  return <img src={url} alt={alt} className={className} />;
}